module.exports = __webpack_public_path__ + "vue-app/img/logo-tl-en.66a27da5.png";